// Helpers
import { inviteeDetails, dateTimeDisplay } from '../userInvitationsHelpers'

// Components
import AccessDetails from './AccessDetails'
import InvitationStatus from './InvitationStatus'
import RecordActions from './RecordActions'

const TableRow = ({ invitation }) => (
  <tr>
    <td>{inviteeDetails(invitation)}</td>
    <td>{dateTimeDisplay(invitation.created_at, true)}</td>
    <td><AccessDetails invitation={invitation} /></td>
    <td><InvitationStatus invitation={invitation} /></td>
    <td><RecordActions invitation={invitation} /></td>
  </tr>
)
export default connect()(TableRow)



// WEBPACK FOOTER //
// ./app/javascript/reactFeatures/company-users/components/user-invitations/components/TableRow.js